import React, { useRef, useEffect, useMemo } from "react";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var TERRITORY_TYPE = /* @__PURE__ */ ((TERRITORY_TYPE2) => {
  TERRITORY_TYPE2["SYNC_PROPS"] = "SYNC_PROPS";
  TERRITORY_TYPE2["REGISTER"] = "REGISTER";
  TERRITORY_TYPE2["ON_UPDATE"] = "ON_UPDATE";
  return TERRITORY_TYPE2;
})(TERRITORY_TYPE || {});
const stringify = (data) => {
  if (!data) {
    return data;
  }
  try {
    return JSON.stringify(data);
  } catch (error) {
    return data;
  }
};
const parse = (data) => {
  if (!data || typeof data !== "string") {
    return data;
  }
  try {
    return JSON.parse(data);
  } catch (error) {
    return data;
  }
};
class RnWebMessager {
  constructor() {
    __publicField(this, "targetPort");
    __publicField(this, "onMessage");
    __publicField(this, "postMessage", (data, port) => {
      (port || this.targetPort).postMessage(stringify(data));
    });
    __publicField(this, "handleMessage", (e) => {
      var _a;
      const data = parse(e.data);
      (_a = this.onMessage) == null ? void 0 : _a.call(this, data);
    });
    __publicField(this, "setTargetPort", (source) => {
      if (!this.targetPort && source) {
        this.targetPort = source;
      }
    });
    __publicField(this, "init", ({ onMessage }) => {
      this.onMessage = onMessage;
      window.addEventListener("message", this.handleMessage);
      document.addEventListener("message", this.handleMessage);
    });
    __publicField(this, "deposit", () => {
      window.removeEventListener("message", this.handleMessage);
      document.removeEventListener("message", this.handleMessage);
      this.onMessage = null;
    });
    this.targetPort = window.ReactNativeWebView;
  }
}
class WebMessager {
  constructor(targetPort) {
    __publicField(this, "targetPort");
    __publicField(this, "targetSource", "*");
    __publicField(this, "onMessage");
    __publicField(this, "postMessage", (data, port) => {
      if (!port && !this.targetPort) {
        console.error("targetPort is empty");
        return;
      }
      (port || this.targetPort).postMessage(data, this.targetSource);
    });
    __publicField(this, "handleMessage", (e) => {
      var _a;
      (_a = this.onMessage) == null ? void 0 : _a.call(this, e.data, e.source);
    });
    __publicField(this, "setTargetPort", (source) => {
      if (!this.targetPort && source) {
        this.targetPort = source;
      }
    });
    __publicField(this, "init", ({
      onMessage,
      targetSource
    }) => {
      this.onMessage = onMessage;
      this.targetSource = targetSource;
      window.addEventListener("message", this.handleMessage);
    });
    __publicField(this, "deposit", () => {
      this.onMessage = null;
      window.removeEventListener("message", this.handleMessage);
    });
    this.targetPort = targetPort;
  }
}
class TerritoryEvent {
  constructor({
    id,
    messager,
    onMessage,
    targetPort,
    targetSource
  }) {
    __publicField(this, "boxId");
    __publicField(this, "onMessage");
    __publicField(this, "mgr");
    __publicField(this, "handleMessage", (data, source) => {
      var _a, _b;
      if (!data.boxId || data.boxId !== this.boxId) {
        return;
      }
      (_a = this.mgr) == null ? void 0 : _a.setTargetPort(source);
      (_b = this.onMessage) == null ? void 0 : _b.call(this, data);
    });
    __publicField(this, "deposit", () => {
      this.mgr.deposit();
      this.mgr = null;
      this.onMessage = null;
    });
    __publicField(this, "postMessage", (type, data) => {
      var _a;
      (_a = this.mgr) == null ? void 0 : _a.postMessage({
        boxId: this.boxId,
        type,
        data
      });
    });
    __publicField(this, "portPostMessage", (port, type, data) => {
      var _a;
      (_a = this.mgr) == null ? void 0 : _a.postMessage(
        {
          boxId: this.boxId,
          type,
          data
        },
        port
      );
    });
    this.onMessage = onMessage;
    this.boxId = id;
    if (messager) {
      this.mgr = messager;
    } else if (!!window.ReactNativeWebView) {
      this.mgr = new RnWebMessager();
    } else {
      this.mgr = new WebMessager(targetPort);
    }
    this.mgr.init({
      onMessage: this.handleMessage,
      targetSource
    });
  }
}
const useEventListen = (territoryEvent, onUpdate, props) => {
  const isRegister = useRef(false);
  useEffect(() => {
    if (isRegister.current) {
      territoryEvent == null ? void 0 : territoryEvent.postMessage(TERRITORY_TYPE.SYNC_PROPS, props);
    }
  }, [props]);
  useEffect(() => {
    territoryEvent.onMessage = (data) => {
      switch (data.type) {
        case TERRITORY_TYPE.REGISTER:
          isRegister.current = true;
          territoryEvent == null ? void 0 : territoryEvent.postMessage(TERRITORY_TYPE.SYNC_PROPS, props);
          break;
        case TERRITORY_TYPE.ON_UPDATE:
          onUpdate == null ? void 0 : onUpdate(data.data);
          break;
      }
    };
    return () => {
      territoryEvent.deposit();
    };
  }, []);
};
const iframeStyle = {
  border: 0,
  width: "100%",
  display: "block",
  overflow: "hidden"
};
const TerritoryBox = ({
  id,
  src,
  style,
  className,
  onUpdate,
  ...rest
}) => {
  const territoryEvent = useRef(
    new TerritoryEvent({
      targetSource: src,
      id: id.toString()
    })
  ).current;
  const iframe = useRef(null);
  const iframeUrl = useMemo(
    () => `${src}?id=${territoryEvent.boxId || ""}&referrer=${location.origin}`,
    [src]
  );
  const _style = useMemo(() => ({ ...iframeStyle, ...style }), []);
  useEventListen(territoryEvent, onUpdate, rest);
  return /* @__PURE__ */ React.createElement("iframe", { src: iframeUrl, ref: iframe, style: _style, className });
};
export {
  TerritoryBox
};
